const theme = {
    formField: {
        required: {
            fontWeight: 500,
        },
    },
};

export default theme;
